import { Link } from "react-router-dom";
import { CalendarCheck, Tag } from "lucide-react";

export const StickyBookBar = ({ showPrices = true }) => (
  <div data-testid="inspection-sticky-bar" className="fixed bottom-0 left-0 right-0 z-50 flex gap-2 border-t border-gold/30 bg-white/95 p-3 backdrop-blur-md md:hidden">
    {showPrices && (
      <a href="/property-inspections#pricing" data-testid="sticky-view-prices"
        className="flex flex-1 items-center justify-center gap-2 rounded-full border border-slate-300 py-3 text-sm font-semibold text-[#0B132B]">
        <Tag className="h-4 w-4 text-gold" /> Prices
      </a>
    )}
    <Link to="/property-inspections/book" data-testid="sticky-book-inspection"
      className="flex flex-[2] items-center justify-center gap-2 rounded-full bg-gold py-3 text-sm font-semibold text-[#0B132B]">
      <CalendarCheck className="h-4 w-4" /> Book Your Inspection
    </Link>
  </div>
);
